<template>
  <div>
    <div class="user-info-head" @click="editCropper()">
      <img v-bind:src="options.img" title="点击上传头像" class="img-circle img-lg" />
    </div>
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body @opened="modalOpened"  @close="closeDialog">
      <el-row>
        <!--  -->
        <el-col :xs="24" :md="12" :style="{height: '350px'}">
          <vue-cropper
            ref="cropper"
            :img="options.img"
            :info="true"
            :autoCrop="options.autoCrop"
            :autoCropWidth="options.autoCropWidth"
            :autoCropHeight="options.autoCropHeight"
            :fixedBox="options.fixedBox"
            @realTime="realTime"
            v-if="visible"
          />
        </el-col>
        <el-col :xs="24" :md="12" :style="{height: '350px',display: 'flex','justify-content': 'center','align-items': 'center',}">
          <div class="avatar-upload-preview">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :lg="2" :md="2">
        <!-- :auto-upload="false"自动上传  -->
          <el-upload 
            ref="upload"
            style="display:flex;"
            action="/api/supinterface/uploadFile" 
            :http-request="requestUpload"  
            :headers="headerObj"
            :show-file-list="false" 
            :before-upload="beforeUpload"
            accept=".bmp, .jpg, .jpeg, .png"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-change="handleChangeImg"
            >
            <el-button slot="trigger" size="small" @click="submitUpload" type="primary">
              Select
              <!-- <i class="el-icon-upload el-icon--right" ></i> -->
            </el-button>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success">上传</el-button> -->
            <!-- <el-button size="small" type="success">
              Upload
              <i class="el-icon-upload el-icon--right"></i>
            </el-button> -->
          </el-upload>
        </el-col>
        <el-col :lg="{span: 1, offset: 2}" :md="2">
          <el-button icon="el-icon-plus" size="small" @click="changeScale(1)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-minus" size="small" @click="changeScale(-1)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
        </el-col>
        <el-col :lg="{span: 2, offset: 6}" :md="2">
          <el-button type="primary" size="small" @click="uploadImg()">Submit</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
// import store from "@/store";
import { VueCropper } from "vue-cropper";
import { User,XQbasic } from "@/api";

export default {
  components: { VueCropper },
  props: {
    user: {
      type: Object
    }
  },
  computed:{
    loginUser() {
      // return JSON.parse(sessionStorage.getItem('loginUser'));
      return this.$cookies.get('loginUser');
    },
  },
  created(){
    this.handleImg()
    // this.handledatatext()//获取登录用户信息
    // //// console.log(this.beforeApi)
  },
  data() {
    return {
      headerObj:{token:localStorage.getItem('token')},
      // 是否显示弹出层
      open: false,
      // 是否显示cropper
      visible: false,
      // 弹出层标题
      title: "修改头像",
      options: {
        img: '', //裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true // 固定截图框大小 不允许改变
      },
      imgForm:{

      },
      // formData:{
      //   supUserId:'',
      //   file:''
      // },
      // user:{},
      previews: {},
      upFile:{},
    };
  },
  methods: {
    handleChangeImg(val){
      // //// console.log('发生了改变',val)
    },
    // 上传图片
    submitUpload(){
      this.$refs.upload.submit()
      // this.$confirm('Confirm upload?',{
      //   confirmButtonText:'Yes',
      //   cancelButtonText:'No',
      //   type:'warning'
      // }).then(()=>{
        
      // })
        // //// console.log('点击提交')
    },
    // 上传成功调用
    handleSuccess(response, file, fileList){
      this.$message.success('上传成功')
      // //// console.log('上传成功1',response)
      // //// console.log('上传成功2',file,fileList)
    },
    // 上传失败调用
    handleError(err, file, fileList){
      // //// console.log('上传成功1',err)
      // //// console.log('上传成功2',file,fileList)
    },
  // async  handledatatext(){
  //    let data =  await User.getLoginUserDataObj({...this.loginUser})
  //    return data
  //   },
     // 上传图片操作
    uploadImg() {
      let _this = this
      this.$refs.cropper.getCropBlob(async (data) => {
        // console.log('********///////////////////////////////***********',_this.loginUser.userId,_this.upFile)
          let formData = new FormData();
           formData.append("file", data);
           formData.append("sysUserId", _this.loginUser.userId);
          // console.log('打印data****formData',formData)
        let backData = await XQbasic.upAvatar(formData)
        if(backData.code == 0){ //成功
          _this.$message.success(backData.msg);
          //修改成功,修改store仓库
          // console.log('修改头像打印成功****',backData)
            sessionStorage.setItem('loginUser',JSON.stringify(backData.data))
            let loginUser = window.sessionStorage.getItem("loginUser");
            _this.$store.commit("loginUser", loginUser);
            _this.options.img = '/api' +  _this.loginUser.avatar;
            _this.visible = false;
            _this.open = false
            


        }else{
          _this.$message.error(backData.msg)

        }
       
      });
    },
    handleImg(){
      let user = this.loginUser
      this.options.img = '/api' + user.avatar
    },
    // 编辑头像
    editCropper() {
      this.open = true;
    },
    // 打开弹出层结束时的回调
    modalOpened() {
      this.visible = true;
    },
    // 覆盖默认的上传行为
    requestUpload() {
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 上传预处理
    beforeUpload(file) {
      this.upFile = file
      console.log('上传文件之前调用',this.upFile)

      if (file.type.indexOf("image/") == -1) {
        this.$modal.msgError("Invalid file format. Only files with the extensions of JPG/PNG are allowed.");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.options.img = reader.result;
        };
      }
    },
  //  async handledatatext(){
  //     let _this = this
  //   //// console.log( '_this.loginUser',_this.loginUser)
  //     let bydata = await  User.getLoginUserDataObj({..._this.loginUser})
  //     //// console.log("反值" , bydata)
  //     this.$store.commit('loginUser',JSON.stringify(bydata))

  //   },
   
    // 实时预览
    realTime(data) {
      this.previews = data;
    },
    // 关闭窗口
    closeDialog() {
        this.options.img = '/api' +JSON.parse(this.$store.state.loginUser).avatar

      
      // //// console.log('关闭窗口',this.loginUser.supUserAvatar)
      this.visible = false;
    }
  }
};
</script>
<style scoped lang="less" >
.user-info-head {
  position: relative;
  display: inline-block;
  height: 60px;
}

.user-info-head:hover:after {
  content: '+';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  color: #eee;
  // background: rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
  line-height: 60px;
  border-radius: 50%;
}
.avatar-upload-preview{
  border-radius: 50%;
  overflow: hidden;
  height: 200px;
  width: 200px;
}
</style>
<style lang="less" scoped>
/deep/ .img-circle{
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
}
</style>